var _rect, _rect2, _rect3, _g, _rect4, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoadingWoman1 = function SvgLoadingWoman1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 224,
    viewBox: "0 0 500 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110.578,
    y: 175.806,
    width: 17.4206,
    height: 66.0435,
    rx: 4,
    transform: "rotate(60 110.578 175.806)",
    fill: "#FEB45E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 396.859,
    y: 198.151,
    width: 17.4206,
    height: 17.8707,
    rx: 4,
    transform: "rotate(60 396.859 198.151)",
    fill: "#61D5EE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 384.919,
    y: 16.3193,
    width: 42.2421,
    height: 43.3334,
    rx: 8,
    transform: "rotate(60 384.919 16.3193)",
    fill: "#FEB45E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.233 53.6672C377.449 56.4287 371.334 54.79 368.572 50.0069C365.811 45.2239 367.449 39.1082 372.233 36.3467C377.016 33.5852 383.131 35.2239 385.893 40.0069C388.654 44.79 387.016 50.9057 382.233 53.6672ZM378.099 44.5069L375.599 40.1768L373.866 41.1768L377.366 47.239L382.563 44.239L381.563 42.5069L378.099 44.5069Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 162.292,
    y: 20.8896,
    width: 10.8126,
    height: 11.0919,
    rx: 4,
    transform: "rotate(60 162.292 20.8896)",
    fill: "#3CBB73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.3386 6C86.0782 2.68629 93.4172 4.65279 96.731 10.3923L123.225 56.2812C126.539 62.0207 124.572 69.3598 118.833 72.6735L48.8864 113.057C43.1469 116.371 35.8078 114.404 32.4941 108.665L6.00017 62.7758C2.68646 57.0363 4.65295 49.6972 10.3925 46.3834L80.3386 6Z",
    fill: "url(#paint0_linear_114_755)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.128 217.588C247.123 218.106 191.994 223.589 171.332 205.65C150.473 187.539 146.578 165.516 151.022 140.015C155.312 115.4 189.566 107.394 212.176 92.4433C229.635 80.8987 244.386 64.9625 266.182 63.868C288.963 62.724 310.666 72.4062 326.718 86.6915C342.685 100.902 349.995 120.08 351.743 140.015C353.671 161.996 351.92 184.665 336.855 202.269C319.618 222.412 304.759 217.077 276.128 217.588Z",
    fill: "#F86498"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_114_755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 149,
    y: 63,
    width: 204,
    height: 156
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.128 217.588C247.123 218.106 191.994 223.589 171.332 205.65C150.473 187.539 146.578 165.516 151.022 140.015C155.312 115.4 189.566 107.394 212.176 92.4433C229.635 80.8987 244.386 64.9625 266.182 63.868C288.963 62.724 310.666 72.4062 326.718 86.6915C342.685 100.902 349.995 120.08 351.743 140.015C353.671 161.996 351.92 184.665 336.855 202.269C319.618 222.412 304.759 217.077 276.128 217.588Z",
    fill: "#F86498"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_114_755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.002 161.957L266.564 156.019L229.527 157.836V163.568C229.527 163.568 221.196 171.49 217.91 224.218H284.576C284.576 224.218 291.888 177.56 267.002 161.957V161.957Z",
    fill: "#407FFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.532 163.574L267.001 161.958",
    stroke: "black",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.188 187.882L244.862 191.008L248.972 224.226",
    stroke: "black",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.044 150.473L199.276 116.699L221.782 125.137L210.982 157.484C208.767 164.163 201.135 167.319 194.853 164.139C189.843 161.611 187.392 155.838 189.044 150.473V150.473Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.824 98.6637C206.849 92.0794 213.919 88.4734 220.438 90.6998C226.774 92.8669 230.19 99.7295 228.082 106.089L221.776 125.131L199.27 116.694L204.824 98.6578V98.6637Z",
    fill: "#FEFEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.417 147.938L180.713 99.201C180.713 99.201 181.3 90.3963 166.674 89.8693V89.8812C166.479 89.8693 166.284 89.8516 166.082 89.8516H161.191C160.285 89.8516 159.456 90.491 159.332 91.3911C159.19 92.4332 159.918 93.3273 160.895 93.4516L165.828 94.1503L159.119 95.9385L157.864 96.4003L148.727 90.3608C147.999 89.8397 146.981 90.0825 146.56 90.87C146.229 91.4917 146.377 92.2555 146.915 92.7056C147.478 93.1733 148.384 93.9549 149.379 94.8076L147.36 93.5996C146.59 93.1378 145.595 93.4575 145.24 94.2806C144.961 94.926 145.169 95.672 145.743 96.0806C146.235 96.4299 146.868 96.874 147.543 97.3477L146.844 97.0753C146.075 96.7734 145.169 96.9925 144.695 97.6734C144.056 98.5971 144.44 99.8524 145.453 100.273L155.436 104.453C157.159 105.175 158.805 105.625 160.836 105.146L169.736 103.05L189.648 158.791L206.417 147.944V147.938Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.871 127.937L200.626 136.954",
    stroke: "#DB5749",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.831 90.1628L215.275 90.8792C215.275 90.8792 201.443 109.643 229.527 157.841L266.564 156.024L269.352 104.095L264.781 89.3516H248.19L224.837 90.1628H224.831Z",
    fill: "#FEFEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.99 122.221C213.99 122.221 211.236 116.424 213.007 103.587",
    stroke: "#FCE7E4",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.96 143.698L284.583 111.938L263.669 123.786L279.384 154.049C282.611 160.301 290.646 162.226 296.354 158.105C300.902 154.824 302.429 148.737 299.96 143.698Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.276 94.9858C273.244 88.7982 265.701 86.3409 259.608 89.562C253.687 92.6884 251.389 100.007 254.463 105.958L263.664 123.786L284.577 111.938L276.276 94.9917V94.9858Z",
    fill: "#FEFEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.67 123.785L256.067 109.065",
    stroke: "#FCE7E4",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.064 89.3598C331.596 88.6789 330.684 88.4657 329.915 88.7617L325.45 90.5026L329.648 86.9499C330.341 86.3637 330.536 85.3216 330.015 84.5814C329.411 83.7288 328.257 83.5985 327.493 84.2202L323.591 87.3644L326.918 83.0123C327.469 82.2899 327.439 81.2301 326.764 80.6202C325.995 79.9156 324.84 80.0399 324.218 80.8037L317.646 87.6249L310.937 85.8367L315.87 85.138C316.847 85.0137 317.581 84.1196 317.433 83.0775C317.308 82.1774 316.479 81.538 315.574 81.538H310.683C307.793 81.538 304.975 82.5446 302.837 84.463C302.802 84.4926 302.766 84.5104 302.731 84.54C299.729 86.9084 300.824 91.7578 300.824 91.7578L282.403 143.911L300.658 152.011L311.18 96.0033L317.901 96.0151C318.315 96.0566 318.735 96.0507 319.156 96.0151H319.209C319.931 95.95 320.648 95.7783 321.329 95.4941L331.312 91.9592C332.324 91.5328 332.709 90.2835 332.07 89.3598H332.064Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.556 122.226L285.577 136.111",
    stroke: "#DB5749",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.091 47.1517C222.942 47.9392 215.221 49.9465 215.067 51.3498C215.067 51.3498 217.607 61.2795 215.008 63.1328C207.974 68.1421 205.724 77.9653 205.724 77.9653C205.724 77.9653 224.28 91.8622 273.604 77.2725C273.604 77.2725 274.196 71.3632 265.225 67.0763C262.667 65.8506 260.388 64.0092 258.949 61.4986C257.836 59.5565 257.664 58.7334 257.368 56.9926C256.539 52.1254 243.104 34.1133 224.097 47.1576L224.091 47.1517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.82 62.0276C225.045 65.2842 222.587 68.1145 219.331 68.3395C216.074 68.5645 213.244 66.1073 213.019 62.8506C212.794 59.594 215.251 56.7637 218.508 56.5387C221.764 56.3137 224.595 58.771 224.82 62.0276Z",
    fill: "#DB5749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.49 76.5177L228.307 89.3843C228.585 93.9022 230.433 96.9812 234.879 96.6733C238.675 96.4068 243.187 93.3693 243.394 89.5738L241.132 69.3887L227.49 76.5236V76.5177Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.831 90.1667L248.184 89.3555C248.184 89.3555 247.616 100.837 233.737 99.7648C224.085 99.0188 224.831 90.1726 224.831 90.1726V90.1667Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.165 87.1161L243.092 72.5205L227.383 75.2028L228.165 87.1161Z",
    fill: "#DB5749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.41 78.5969C223.807 78.6206 217.53 72.6343 217.305 66.429L216.855 51.786C216.571 44.0056 222.51 37.4035 230.273 36.8647C238.219 36.3141 246.509 42.2115 247.059 50.1577L247.29 61.9407C247.468 71.0534 240.499 77.9633 231.404 78.5969H231.41Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.275 61.2686L224.831 64.9101L226.714 64.9752",
    stroke: "black",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.811 67.4999C229.811 67.4999 227.827 66.5939 225.423 68.6663",
    stroke: "black",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.213 62.0872C255.438 65.3438 252.981 68.1741 249.724 68.3991C246.468 68.6241 243.637 66.1668 243.412 62.9102C243.187 59.6536 245.645 56.8233 248.901 56.5983C252.158 56.3733 254.988 58.8305 255.213 62.0872Z",
    fill: "#F26E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.054 64.1911C247.054 64.1911 246.758 59.916 250.891 60.3009",
    stroke: "black",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.044 150.473L199.276 116.699L221.782 125.137L210.982 157.484C208.767 164.163 201.135 167.319 194.853 164.139C189.843 161.611 187.392 155.838 189.044 150.473V150.473Z",
    fill: "#FFBE9D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.824 98.6637C206.849 92.0794 213.919 88.4734 220.438 90.6998C226.774 92.8669 230.19 99.7295 228.082 106.089L221.776 125.131L199.27 116.694L204.824 98.6578V98.6637Z",
    fill: "#FEFEF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.417 147.938L180.713 99.201C180.713 99.201 181.3 90.3963 166.674 89.8693V89.8812C166.479 89.8693 166.284 89.8516 166.082 89.8516H161.191C160.285 89.8516 159.456 90.491 159.332 91.3911C159.19 92.4332 159.918 93.3273 160.895 93.4516L165.828 94.1503L159.119 95.9385L157.864 96.4003L148.727 90.3608C147.999 89.8397 146.981 90.0825 146.56 90.87C146.229 91.4917 146.377 92.2555 146.915 92.7056C147.478 93.1733 148.384 93.9549 149.379 94.8076L147.36 93.5996C146.59 93.1378 145.595 93.4575 145.24 94.2806C144.961 94.926 145.169 95.672 145.743 96.0806C146.235 96.4299 146.868 96.874 147.543 97.3477L146.844 97.0753C146.075 96.7734 145.169 96.9925 144.695 97.6734C144.056 98.5971 144.44 99.8524 145.453 100.273L155.436 104.453C157.159 105.175 158.805 105.625 160.836 105.146L169.736 103.05L189.648 158.791L206.417 147.944V147.938Z",
    fill: "#FFBE9D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.871 127.937L200.626 136.954",
    stroke: "#FF9A66",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M224.831 90.1628L215.275 90.8792C215.275 90.8792 201.443 109.643 229.527 157.841L266.564 156.024L269.352 104.095L264.781 89.3516H248.19L224.837 90.1628H224.831Z",
    fill: "#FEFEF4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M213.99 122.221C213.99 122.221 211.236 116.424 213.007 103.587",
    stroke: "#FCE7E4",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M299.96 143.698L284.583 111.938L263.669 123.786L279.384 154.049C282.611 160.301 290.646 162.226 296.354 158.105C300.902 154.824 302.429 148.737 299.96 143.698Z",
    fill: "#FFBE9D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M276.276 94.9858C273.244 88.7982 265.701 86.3409 259.608 89.562C253.687 92.6884 251.389 100.007 254.463 105.958L263.664 123.786L284.577 111.938L276.276 94.9917V94.9858Z",
    fill: "#FEFEF4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M263.67 123.785L256.067 109.065",
    stroke: "#FCE7E4",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M332.064 89.3598C331.596 88.6789 330.684 88.4657 329.915 88.7617L325.45 90.5026L329.648 86.9499C330.341 86.3637 330.536 85.3216 330.015 84.5814C329.411 83.7288 328.257 83.5985 327.493 84.2202L323.591 87.3644L326.918 83.0123C327.469 82.2899 327.439 81.2301 326.764 80.6202C325.995 79.9156 324.84 80.0399 324.218 80.8037L317.646 87.6249L310.937 85.8367L315.87 85.138C316.847 85.0137 317.581 84.1196 317.433 83.0775C317.308 82.1774 316.479 81.538 315.574 81.538H310.683C307.793 81.538 304.975 82.5446 302.837 84.463C302.802 84.4926 302.766 84.5104 302.731 84.54C299.729 86.9084 300.824 91.7578 300.824 91.7578L282.403 143.911L300.658 152.011L311.18 96.0033L317.901 96.0151C318.315 96.0566 318.735 96.0507 319.156 96.0151H319.209C319.931 95.95 320.648 95.7783 321.329 95.4941L331.312 91.9592C332.324 91.5328 332.709 90.2835 332.07 89.3598H332.064Z",
    fill: "#FFBE9D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M289.556 122.226L285.577 136.111",
    stroke: "#FF9A66",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.091 47.1517C222.942 47.9392 215.221 49.9465 215.067 51.3498C215.067 51.3498 217.607 61.2795 215.008 63.1328C207.974 68.1421 205.724 77.9653 205.724 77.9653C205.724 77.9653 224.28 91.8622 273.604 77.2725C273.604 77.2725 274.196 71.3632 265.225 67.0763C262.667 65.8506 260.388 64.0092 258.949 61.4986C257.836 59.5565 257.664 58.7334 257.368 56.9926C256.539 52.1254 243.104 34.1133 224.097 47.1576L224.091 47.1517Z",
    fill: "#0B072A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M224.82 62.0276C225.045 65.2842 222.587 68.1145 219.331 68.3395C216.074 68.5645 213.244 66.1073 213.019 62.8506C212.794 59.594 215.251 56.7637 218.508 56.5387C221.764 56.3137 224.595 58.771 224.82 62.0276Z",
    fill: "#FF9A66"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.49 76.5177L228.307 89.3843C228.585 93.9022 230.433 96.9812 234.879 96.6733C238.675 96.4068 243.187 93.3693 243.394 89.5738L241.132 69.3887L227.49 76.5236V76.5177Z",
    fill: "#FFBE9D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.831 90.1667L248.184 89.3555C248.184 89.3555 247.616 100.837 233.737 99.7648C224.085 99.0188 224.831 90.1726 224.831 90.1726V90.1667Z",
    fill: "#FFBE9D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M228.165 87.1161L243.092 72.5205L227.383 75.2028L228.165 87.1161Z",
    fill: "#FF9A66"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M231.41 78.5969C223.807 78.6206 217.53 72.6343 217.305 66.429L216.855 51.786C216.571 44.0056 222.51 37.4035 230.273 36.8647C238.219 36.3141 246.509 42.2115 247.059 50.1577L247.29 61.9407C247.468 71.0534 240.499 77.9633 231.404 78.5969H231.41Z",
    fill: "#FFBE9D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M230.81 69.5516C230.651 69.7506 229.369 68.6375 227.459 68.9833C225.549 69.3291 224.493 70.8147 224.308 70.6676C224.225 70.6016 224.331 70.141 224.828 69.5415C225.49 68.772 226.396 68.2529 227.392 68.0714C228.328 67.9034 229.29 68.0989 230.083 68.618C230.706 69.0399 230.899 69.4655 230.81 69.5516Z",
    fill: "#0B072A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M236.659 56.4761C236.422 56.7134 235.408 56.0747 234.076 55.6255C232.743 55.1763 231.558 55.0389 231.513 54.6988C231.5 54.5437 231.799 54.3552 232.336 54.2949C233.049 54.2069 233.774 54.2878 234.45 54.5309C235.133 54.758 235.751 55.1445 236.253 55.6581C236.647 56.0188 236.773 56.3625 236.659 56.4761Z",
    fill: "#0B072A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M222.624 56.0096C222.495 56.3203 221.63 56.2703 220.676 56.5178C219.723 56.7652 218.962 57.1672 218.704 56.9508C218.585 56.8427 218.642 56.549 218.932 56.2371C219.329 55.8207 219.839 55.5275 220.401 55.393C220.962 55.2585 221.55 55.2883 222.095 55.4789C222.502 55.6402 222.682 55.8754 222.624 56.0096Z",
    fill: "#0B072A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M225.275 61.2686L224.831 64.9101L226.713 64.9752",
    stroke: "#0B072A",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M222.456 59.8853C222.48 60.6255 221.9 61.2472 221.16 61.2709C220.42 61.2945 219.798 60.7143 219.774 59.9741C219.75 59.234 220.331 58.6123 221.071 58.5886C221.811 58.5649 222.433 59.1452 222.456 59.8853Z",
    fill: "#0B072A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M233.737 59.5152C233.76 60.2553 233.18 60.8771 232.44 60.9007C231.7 60.9244 231.078 60.3442 231.054 59.604C231.031 58.8639 231.611 58.2422 232.351 58.2185C233.091 58.1948 233.713 58.7751 233.737 59.5152Z",
    fill: "#0B072A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M234.974 34.348C233.079 34.2474 231.166 34.4546 229.337 34.9461C224.783 36.1599 216.612 39.529 215.209 48.2745C214.741 50.5779 215.067 51.3535 215.067 51.3535C215.067 51.3535 230.332 51.9516 239.361 47.6883C240.658 53.1891 241.86 56.5937 247.296 61.9464L252.121 54.699L257.551 59.5661C257.587 59.7497 257.581 35.55 234.986 34.348H234.974Z",
    fill: "#0B072A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M255.213 62.0872C255.438 65.3438 252.981 68.1741 249.724 68.3991C246.468 68.6241 243.637 66.1668 243.412 62.9102C243.187 59.6536 245.645 56.8233 248.901 56.5983C252.158 56.3733 254.988 58.8305 255.213 62.0872Z",
    fill: "#FFBE9D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M251.072 60.0637C251.072 60.3178 249.376 60.2441 248.096 61.7032C246.816 63.1624 246.913 64.9823 246.677 64.9823C246.571 64.9823 246.367 64.556 246.383 63.7772C246.423 62.7628 246.809 61.7931 247.476 61.031C248.104 60.3175 248.979 59.8718 249.922 59.785C250.673 59.7276 251.089 59.9408 251.072 60.0637Z",
    fill: "#0B072A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_114_755",
    x1: 109.978,
    y1: 33.3367,
    x2: 19.2471,
    y2: 85.7202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(360.84 40.6143) rotate(-30)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoadingWoman1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "loading_woman_1.92a14f8.svg";